mutation DefineRevitParameter(
    $parameterID: ID!
    $bimClassID: ID
    $revitBuiltInParameterID: ID
    $revitSharedParameterDefinition: RevitSharedParameterDefinitionInput
) {
    defineRevitParameter(
        parameterID: $parameterID
        bimClassID: $bimClassID
        revitBuiltInParameterID: $revitBuiltInParameterID
        revitSharedParameterDefinition: $revitSharedParameterDefinition
    ) {
        id
        parameterID
        ... on RevitBuiltInParameterTemplate {
            bimClassID
            revitBuiltInParameterID
        }
        ... on RevitSharedParameterTemplate {
            revitSharedParameterDefinition {
                group
                instance
                modifiable
                type
                visible
            }
        }
    }
}
